(function() {
  var sectionId = '#shopify-section-template--30638652424529__carousel_HQxWi6';

  function applyMobileStyles() {
    var section = document.querySelector(sectionId);
    if (!section) return;
    var isMobile = window.innerWidth <= 749;
    section.querySelectorAll('.card__content, .card__inner').forEach(function(el) {
      el.style.setProperty('display', isMobile ? 'none' : '', 'important');
    });
  }

  function init() {
    var section = document.querySelector(sectionId);
    if (!section) return;

    applyMobileStyles();

    // Watch for DOM changes (cloned cards, re-renders)
    var observer = new MutationObserver(applyMobileStyles);
    observer.observe(section, { childList: true, subtree: true });
  }

  // Try repeatedly until section is found
  var attempts = 0;
  var interval = setInterval(function() {
    var section = document.querySelector(sectionId);
    if (section || attempts >= 20) {
      clearInterval(interval);
      init();
    }
    attempts++;
  }, 300);

  window.addEventListener('resize', applyMobileStyles);
})();
